// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fuse-material-color-picker-menu {
  width: 208px;
}
.fuse-material-color-picker-menu .mat-menu-content {
  padding: 0;
}
.fuse-material-color-picker-menu .mat-menu-content .views {
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  min-height: 258px;
  height: 308px;
  background-color: #F7F7F7;
}
.fuse-material-color-picker-menu .mat-menu-content .views .view {
  position: absolute;
  width: 208px;
  height: 100%;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
}
.fuse-material-color-picker-menu .mat-menu-content .views .view .colors {
  position: relative;
  padding: 4px;
}
.fuse-material-color-picker-menu .mat-menu-content .views .view .colors .color {
  position: relative;
  width: 46px;
  height: 46px;
  margin: 2px;
  border-radius: 0;
  cursor: pointer;
}
.fuse-material-color-picker-menu .mat-menu-content .views .view .colors .color .label {
  padding: 2px;
  font-size: 10px;
}
.fuse-material-color-picker-menu .mat-menu-content .views .view .colors .color mat-icon {
  position: absolute;
  top: 2px;
  right: 2px;
  font-size: 16px;
  opacity: 0.7;
}`, "",{"version":3,"sources":["webpack://./src/@fuse/components/material-color-picker/material-color-picker.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;AACI;EACI,UAAA;AACR;AACQ;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,yBAAA;AACZ;AACY;EACI,kBAAA;EACA,YAAA;EACA,YAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;AAChB;AACgB;EACI,kBAAA;EACA,YAAA;AACpB;AACoB;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AACxB;AACwB;EACI,YAAA;EACA,eAAA;AAC5B;AAEwB;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;AAA5B","sourcesContent":[".fuse-material-color-picker-menu {\r\n    width: 208px;\r\n\r\n    .mat-menu-content {\r\n        padding: 0;\r\n\r\n        .views {\r\n            display: flex;\r\n            flex-direction: column;\r\n            position: relative;\r\n            overflow: hidden;\r\n            min-height: 258px;\r\n            height: 308px;\r\n            background-color: #F7F7F7;\r\n\r\n            .view {\r\n                position: absolute;\r\n                width: 208px;\r\n                height: 100%;\r\n                bottom: 0;\r\n                left: 0;\r\n                right: 0;\r\n                top: 0;\r\n\r\n                .colors {\r\n                    position: relative;\r\n                    padding: 4px;\r\n\r\n                    .color {\r\n                        position: relative;\r\n                        width: 46px;\r\n                        height: 46px;\r\n                        margin: 2px;\r\n                        border-radius: 0;\r\n                        cursor: pointer;\r\n\r\n                        .label {\r\n                            padding: 2px;\r\n                            font-size: 10px;\r\n                        }\r\n\r\n                        mat-icon {\r\n                            position: absolute;\r\n                            top: 2px;\r\n                            right: 2px;\r\n                            font-size: 16px;\r\n                            opacity: 0.7;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
